import { formatMoney } from 'common/src/other/currencyFormat';
import React,{ useState, useEffect, useRef } from 'react';
import MaterialTable, { MTableToolbar } from 'material-table';
import {
  Grid,
  Typography,
  Button,
  Modal,
  TextField,
  FormControl,
  FormLabel,
  Select,
  MenuItem,
  Box,
} from '@mui/material';
import LocalAtmOutlinedIcon from '@mui/icons-material/LocalAtmOutlined';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';
import { makeStyles } from '@mui/styles';
import { useSelector, useDispatch } from "react-redux";
import { api } from 'common';
import { useTranslation } from "react-i18next";
import moment from 'moment/min/moment-with-locales';
import AlertDialog from '../components/AlertDialog';
import AlertDialogTwoButton from '../components/AlertDialogTwoButton';
import styles from '../styles/landingPage.js';
import { useNavigate } from 'react-router-dom';
import {colors} from '../components/Theme/WebTheme';
import { MAIN_COLOR } from "../common/sharedFunctions";
import {
  C2_FONT,
  c2ModalBoxSx,
  c2TextFieldSx,
  c2PrimaryBtnSx,
  c2SecondaryBtnSx,
  c2SuccessBtnSx,
} from '../components/conecta2ModalStyles';

const FONT = "'Outfit', 'Poppins', sans-serif";

const useStyles = makeStyles(theme => ({
  ...styles,
  modal: {
    display: 'flex',
    padding: theme.spacing(1),
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    width: 400,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  inputRtl: {
    "& label": {
      right: 10,
      left: "auto",
      paddingRight: 20
    },
    "& legend": {
      textAlign: "right",
      marginRight: 20
    }
  },
  textField: {
    "& label.Mui-focused": {
      color: MAIN_COLOR,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: MAIN_COLOR,
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: MAIN_COLOR,
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: MAIN_COLOR,
      },
    },
  },
  selectField: {
    color: "black",
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: MAIN_COLOR,
    },
  },
}));

const icons = {
  'mercadopago':require('../assets/payment-icons/mercadopago-logo.png').default,
  'openpay':require('../assets/payment-icons/credicard.png').default,
  'pse':require('../assets/payment-icons/pse.png').default,
  'epayco':require('../assets/payment-icons/epayco-logo.jpg').default,
}

function formatBonusAmount(value) {
  return formatMoney(Math.round(Number(value) || 0), { country: 'Colombia', code: 'COP', decimal: 0 });
}

function typeBadgeLabel(type, t) {
  const raw = String(type || '');
  if (/credit/i.test(raw)) return t('credited');
  if (/withdraw/i.test(raw)) return t('withdrawn');
  if (/debit/i.test(raw)) return t('debited');
  return t(raw);
}

function typeBadgeColor(type) {
  const raw = String(type || '');
  if (/credit/i.test(raw)) return '#22C55E';
  if (/withdraw/i.test(raw)) return '#F59E0B';
  return '#EF4444';
}

const UserWallet = (props) => {
  const {
    withdrawReferral,
  } = api;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const classes = useStyles();
  const { t,i18n } = useTranslation();
  const isRTL      = i18n.dir();
  const auth      = useSelector(state => state.auth);
  const settings   = useSelector(state => state.settingsdata.settings);
  const providers  = useSelector(state => state.paymentmethods.providers);
  const list_bonus = useSelector(state => state.referralBonus.bonus);
  const [profile,setProfile] = useState();
  const paydaysLabel = api.formatWithdrawPaydays ? api.formatWithdrawPaydays() : '15 y 30';
  const [data,setData] = useState([]);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });
  const [commonAlertTwoButton, setCommonAlertTwoButton] = useState({ open: false, msg: '' });
  const rootRef = useRef(null);
  const [amount,setAmount] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const [modalInfo,setModalInfo] = useState({
    mOpen: false,
    mType: null
  });
  const [selectedProvider, setSelectedProvider] = useState();
  const [selectedProviderIndex, setSelectedProviderIndex] = useState(0);
  const [paymentModalStatus, setPaymentModalStatus] = useState(false);
  const columns =  [
      {
        title: t('requestDate'),
        field: 'time',
        defaultSort:'desc',
        render: rowData =>
          rowData.time
            ? moment(rowData.time).locale('es').format('D [de] MMM [de] YYYY HH:mm')
            : null,
      },
      {
        title: t('amount'),
        field: 'amount',
        editable: 'never',
        render: (rowData) => (
          <Typography
            component="span"
            sx={{
              fontFamily: FONT,
              fontWeight: 700,
              fontSize: '0.95rem',
              color: '#1A0F3B',
            }}
          >
            {formatBonusAmount(rowData.amount || 0)}
          </Typography>
        ),
     },
     { title: t('Description'), field: 'concepto', render: rowData => rowData.concepto ? rowData.concepto : rowData.txRef, },
     {
      title: t('type'),
      field: 'type',
      render: (rowData) => (
        <Box
          component="span"
          sx={{
            display: 'inline-block',
            backgroundColor: typeBadgeColor(rowData.type),
            color: '#FBFAFE',
            px: 2,
            py: 0.6,
            borderRadius: '999px',
            fontWeight: 700,
            fontSize: '0.72rem',
            letterSpacing: '0.04em',
            fontFamily: FONT,
            minWidth: 110,
            textAlign: 'center',
          }}
        >
          {typeBadgeLabel(rowData.type, t)}
        </Box>
      ),
    },
  ];

  useEffect(() =>{
      if(auth.profile){
                            let id_cli = auth.profile.uid;
                            const {
                                   list_referralBonus,
                            } = api
                            dispatch(list_referralBonus(id_cli));
                      }
        },[auth.profile, dispatch]);

  useEffect(() =>{
      if(list_bonus){
                            setData(list_bonus);
                      }
        },[list_bonus]);

  useEffect(()=>{
    if(providers){
      setSelectedProvider(providers[0]);
    }
  },[providers]);

  useEffect(()=>{
    if(auth.profile){
        setProfile(auth.profile);
    } else{
        setProfile(null);
    }
  },[auth.profile]);

  const doWithdraw = (e) => {
    e.preventDefault();

    if(!(profile.mobile && profile.mobile.length > 6 && profile.email && profile.firstName)){
      setCommonAlertTwoButton({
        open: true,
        msg: t('profile_incomplete', {
          defaultValue: 'Completa tu perfil (nombre, correo y teléfono) para continuar.',
        }),
      })
    }else{
      const isPayday = api.getWithdrawPaydayKey
        ? !!api.getWithdrawPaydayKey()
        : [15, 30].includes(new Date().getDate());
            if(isPayday){
              
                    if ((parseFloat(profile.walletReferral) || 0) >= (api.MIN_REFERRAL_WITHDRAW || 100000)) {
                          setModalInfo({
                            mOpen: true,
                            mType: 'withdraw'
                          });
                    } else {
                      setCommonAlert({
                        open: true,
                        msg: t('wallet_bal_low_b', {
                          defaultValue:
                            'Saldo insuficiente. Necesitas al menos COP$ 100.000 para retirar.',
                        }),
                      })
                    }

              }else{
                setCommonAlert({
                  open: true,
                  msg: `Solo puedes retirar los días ${paydaysLabel} de este mes.`,
                })
                return;
            }
        }
    }
  

  const gotoOperation = () => {
    navigate('/profile');
    setCommonAlert({ open: false, msg: '' })
  };

  const cancelOperation = () => {
    setAmount(0);
    setModalInfo({
      mOpen: false,
      mType: null
    });
    setCommonAlert({ open: false, msg: '' })
  };

  const cancelOperationTowButton = () => {
    setAmount(0);
    setModalInfo({
      mOpen: false,
      mType: null
    });
    setCommonAlertTwoButton({ open: false, msg: '' })
  };

  const handleSubmit = (e) => {

    e.preventDefault();
  
    if(amount <= 0){
      setCommonAlert({ open: true, msg: t('valid_amount')});
    } else {
       if(modalInfo.mType === 'add'){
        setModalInfo({
          ...modalInfo,
          mOpen: false
        });
        setPaymentModalStatus(true);
       }else{
        const bal = parseFloat(profile.walletReferral) || 0;
        if (bal < amount) {
          setCommonAlert({ open: true, msg: t('valid_amount')});
          return;
        }
        const minWithdraw = api.MIN_REFERRAL_WITHDRAW || 100000;
        if (amount < minWithdraw) {
          setCommonAlert({ open: true, msg: `El retiro mínimo es ${api.formatCop(minWithdraw)}.` });
          return;
        }
        const wCap = api.formatWithdrawCapProgress
          ? api.formatWithdrawCapProgress(profile, profile?.uid || profile?.id)
          : null;
        if (wCap && amount > wCap.withdrawable) {
          setCommonAlert({
            open: true,
            msg: wCap.isPayday
              ? `Tope del día ${wCap.payday}: ${api.formatCop(wCap.cap)} (mitad de ${api.formatCop(wCap.monthlyCap)}/mes). Disponible hoy: ${api.formatCop(wCap.withdrawable)}.`
              : `Retiros solo los días ${paydaysLabel}. Cupo por día: ${api.formatCop(wCap.cap)}.`,
          });
          return;
        }
        Promise.resolve(dispatch(withdrawReferral(profile, amount))).then((res) => {
          if (res && res.ok === false) {
            setCommonAlert({
              open: true,
              msg: res.message || t('valid_amount'),
            });
            return;
          }
          const f = api.computeReferralWithdrawFee ? api.computeReferralWithdrawFee(amount) : null;
          cancelOperation();
          setCommonAlert({
            open: true,
            msg:
              res?.message ||
              (f
                ? `Solicitud de retiro registrada. Recibirás ${api.formatCop(f.net)} en tu cuenta bancaria (fee de plataforma ${f.feePercent}%: ${api.formatCop(f.fee)}).`
                : 'Solicitud de retiro registrada. El equipo realizará la transferencia a tu cuenta bancaria.'),
          });
        }).catch(() => {
          setCommonAlert({
            open: true,
            msg: 'No pudimos registrar tu solicitud de retiro. Intenta de nuevo más tarde.',
          });
        });
       }
    }
  }

  const createOrderId = () =>{
    const c = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    const reference = [...Array(4)].map(_ => c[~~(Math.random()*c.length)]).join('');
    return "wallet-" + auth.profile.uid + "-" + reference
  }

  const handlePaymentModalClose = (e) => {
    setTimeout(()=>{
      setPaymentModalStatus(false);
    },1500);
  }

  const cap = api.formatEarningsCapProgress
    ? api.formatEarningsCapProgress(profile, profile?.uid || profile?.id)
    : null;
  const wCap =
    api.formatWithdrawCapProgress &&
    api.formatWithdrawCapProgress(profile, profile?.uid || profile?.id);

  const tableOptions = {
    exportButton: true,
    showTitle: false,
    searchFieldAlignment: 'right',
    toolbarButtonAlignment: 'right',
    searchFieldStyle: {
      borderRadius: 10,
      border: '1px solid #D7CFEB',
      padding: '2px 8px',
      fontFamily: FONT,
      backgroundColor: '#FBFAFE',
    },
    rowStyle: (rowData) => ({
      backgroundColor:
        selectedRow === rowData.tableData.id ? '#EBE7FB' : '#FBFAFE',
      borderBottom: '1px solid #EDE8F7',
      fontFamily: FONT,
    }),
    headerStyle: {
      backgroundColor: '#EBE7FB',
      color: '#1A0F3B',
      textAlign: 'center',
      fontSize: '0.8em',
      fontWeight: 700,
      fontFamily: FONT,
      border: '1px solid #D7CFEB',
      padding: '12px 10px',
    },
    cellStyle: {
      border: '1px solid #EDE8F7',
      textAlign: 'center',
      margin: 'auto',
      fontFamily: FONT,
      color: '#221448',
      fontSize: '0.88em',
    },
  };

  return (
    <Box sx={{ px: { xs: 0.5, sm: 1 }, pb: 3 }}>
      <Typography
        sx={{
          fontFamily: FONT,
          fontWeight: 800,
          fontSize: { xs: '1.6rem', sm: '2rem' },
          color: '#1A0F3B',
          letterSpacing: '0.04em',
          textTransform: 'uppercase',
          mb: 2,
          textAlign: isRTL === 'rtl' ? 'right' : 'left',
        }}
      >
        {t('Referral_bonus') || 'BONUS DE REFERIDO'}
      </Typography>

      <Grid container spacing={2} sx={{ mb: 1.5 }} alignItems="stretch">
        <Grid item xs={12} md={7}>
          <Box
            sx={{
              height: '100%',
              position: 'relative',
              overflow: 'hidden',
              borderRadius: '18px',
              background: 'linear-gradient(105deg, #6411ED 0%, #7628FF 48%, #5B0FD9 100%)',
              boxShadow: '0 12px 32px rgba(100,17,237,0.28)',
              px: { xs: 2, sm: 2.5 },
              py: { xs: 2.5, sm: 3 },
              minHeight: 150,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              gap: 2,
            }}
          >
            <Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box
                  sx={{
                    width: 56,
                    height: 56,
                    borderRadius: '14px',
                    backgroundColor: 'rgba(251,250,254,0.16)',
                    border: '1px solid rgba(251,250,254,0.28)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}
                >
                  <LocalAtmOutlinedIcon sx={{ color: '#FBFAFE', fontSize: 30 }} />
                </Box>
                <Box>
                  <Typography
                    sx={{
                      fontFamily: FONT,
                      fontSize: '0.85rem',
                      color: 'rgba(251,250,254,0.88)',
                      mb: 0.3,
                    }}
                  >
                    {t('Balance') || 'Balance'}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: FONT,
                      fontWeight: 800,
                      fontSize: { xs: '1.6rem', sm: '2rem' },
                      color: '#FBFAFE',
                      lineHeight: 1.1,
                    }}
                  >
                    {formatBonusAmount(profile?.walletReferral || 0)}
                  </Typography>
                </Box>
              </Box>
              <Typography
                sx={{
                  mt: 2,
                  fontFamily: FONT,
                  fontSize: '0.85rem',
                  color: 'rgba(251,250,254,0.85)',
                  lineHeight: 1.4,
                }}
              >
                Tu saldo de bonus por referidos. Retiros los días {paydaysLabel}.
              </Typography>
            </Box>
            <Button
              onClick={doWithdraw}
              variant="contained"
              sx={{
                alignSelf: { xs: 'stretch', sm: 'flex-start' },
                borderRadius: '12px',
                textTransform: 'none',
                fontFamily: FONT,
                fontWeight: 700,
                fontSize: '0.95rem',
                px: 3,
                py: 1.1,
                minWidth: 140,
                maxWidth: { sm: 200 },
                background: 'linear-gradient(135deg, #22C55E 0%, #16A34A 100%)',
                boxShadow: '0 6px 16px rgba(34,197,94,0.35)',
                color: '#FBFAFE',
                '&:hover': {
                  background: 'linear-gradient(135deg, #16A34A 0%, #15803D 100%)',
                },
              }}
            >
              {t('withdraw')}
            </Button>
          </Box>
        </Grid>

        <Grid item xs={12} md={5}>
          <Box
            sx={{
              height: '100%',
              borderRadius: '18px',
              backgroundColor: '#FBFAFE',
              border: '1px solid #D7CFEB',
              boxShadow: '0 8px 24px rgba(26,15,59,0.06)',
              p: 2.5,
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: '12px',
                  backgroundColor: '#EBE7FB',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <TrendingUpOutlinedIcon sx={{ color: '#6411ED', fontSize: 22 }} />
              </Box>
              <Typography
                sx={{ fontFamily: FONT, fontWeight: 700, fontSize: '0.95rem', color: '#1A0F3B' }}
              >
                Tope generación / retiro
              </Typography>
            </Box>
            {cap ? (
              <>
                <Typography sx={{ fontFamily: FONT, fontWeight: 700, color: '#6411ED', fontSize: '1rem' }}>
                  {cap.label}
                </Typography>
                <Typography sx={{ fontFamily: FONT, fontSize: '0.82rem', color: '#766293', lineHeight: 1.45 }}>
                  {wCap
                    ? wCap.isPayday
                      ? `Retiro día ${wCap.payday}: ${wCap.label} · disp. ${api.formatCop(wCap.withdrawable)}`
                      : `Retiro 15/30 · ${api.formatCop(wCap.cap)} c/u (mitad de ${api.formatCop(wCap.monthlyCap)})`
                    : `Generado ${cap.pct}%`}
                </Typography>
              </>
            ) : (
              <Typography sx={{ fontFamily: FONT, fontSize: '0.85rem', color: '#766293' }}>
                Información de tope no disponible.
              </Typography>
            )}
          </Box>
        </Grid>
      </Grid>

      <Box
        sx={{
          backgroundColor: '#FBFAFE',
          borderRadius: '16px',
          border: '1px solid #D7CFEB',
          boxShadow: '0 8px 24px rgba(26,15,59,0.06)',
          overflow: 'hidden',
          p: { xs: 1, sm: 1.5 },
        }}
      >
        <MaterialTable
          title=""
          columns={columns}
          style={{
            direction: isRTL === 'rtl' ? 'rtl' : 'ltr',
            borderRadius: '12px',
            boxShadow: 'none',
            backgroundColor: 'transparent',
          }}
          data={data}
          onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
          components={{
            Toolbar: (toolbarProps) => (
              <Box
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: 1,
                  width: '100%',
                  px: 0.5,
                  mb: 0.5,
                  '& .MuiToolbar-root': {
                    minHeight: 52,
                    paddingLeft: '0 !important',
                    paddingRight: '0 !important',
                    flex: '1 1 auto',
                    justifyContent: 'flex-end',
                  },
                  '& .MuiIconButton-root': {
                    color: '#6411ED',
                    border: '1px solid #D7CFEB',
                    borderRadius: '10px',
                    width: 40,
                    height: 40,
                    backgroundColor: '#FBFAFE',
                    '&:hover': { backgroundColor: '#EBE7FB' },
                  },
                }}
              >
                <Typography
                  sx={{
                    fontFamily: FONT,
                    fontWeight: 800,
                    fontSize: { xs: '0.95rem', sm: '1.05rem' },
                    color: '#1A0F3B',
                    letterSpacing: '0.03em',
                    textTransform: 'uppercase',
                    flexShrink: 0,
                  }}
                >
                  {t('transaction_history_title') || 'HISTORIAL DE TRANSACCIONES'}
                </Typography>
                <MTableToolbar {...toolbarProps} />
              </Box>
            ),
          }}
          options={tableOptions}
          localization={{
            toolbar: {
              searchPlaceholder: (t('search')),
              exportTitle: (t('export')),
            },
            pagination: {
              labelDisplayedRows: ('{from}-{to} '+ (t('of'))+ ' {count}'),
              firstTooltip: (t('first_page_tooltip')),
              previousTooltip: (t('previous_page_tooltip')),
              nextTooltip: (t('next_page_tooltip')),
              lastTooltip: (t('last_page_tooltip'))
            },
          }}
        />
      </Box>

      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={paymentModalStatus}
        onClose={handlePaymentModalClose}
        className={classes.modal}
        container={rootRef.current}
      >
        <Box sx={{ ...c2ModalBoxSx, direction: isRTL === 'rtl' ? 'rtl' : 'ltr' }}>
        {providers && selectedProvider && modalInfo.mType === 'add'  && amount>0?
          <form action={selectedProvider.link} method="POST">
            <input type='hidden' name='order_id' value={createOrderId()}/>
            <input type='hidden' name='amount' value={amount}/>
            <input type='hidden' name='currency' value={settings.code}/>
            <input type='hidden' name='product_name' value={t('add_money')}/>
            <input type='hidden' name='first_name' value={profile.firstName}/>
            <input type='hidden' name='last_name' value={profile.lastName}/>
            <input type='hidden' name='quantity' value={1}/>
            <input type='hidden' name='cust_id' value={auth.profile.uid}/>
            <input type='hidden' name='mobile_no' value={profile.mobile}/>
            <input type='hidden' name='email' value={profile.email}/>
            <Typography sx={{ fontFamily: C2_FONT, fontWeight: 800, fontSize: '1.15rem', color: '#1A0F3B', mb: 2 }}>
              {t('payment', { defaultValue: 'Pago' })}
            </Typography>
            <FormControl fullWidth sx={{ mb: 2.5 }}>
              <FormLabel sx={{ fontFamily: C2_FONT, color: '#766293', mb: 1 }}>{t('payment')}</FormLabel>
              <Select
                fullWidth
                id="selectedProviderIndex"
                name="selectedProviderIndex"
                value={selectedProviderIndex}
                label={t('payment')}
                onChange={(e)=>{
                    setSelectedProviderIndex(parseInt(e.target.value));
                    setSelectedProvider(providers[parseInt(e.target.value)]);
                }}
                sx={{
                  borderRadius: '12px',
                  fontFamily: C2_FONT,
                  textAlign: isRTL === 'rtl' ? 'right' : 'left',
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#D7CFEB' },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#6411ED' },
                }}
                inputProps={{ 'aria-label': 'Without label' }}
              >
                {providers.map((provider,index) =>
                   <MenuItem key={provider.name} value={index} style={{ width:'100%', justifyContent:'center', paddingLeft:10}}><img style={{height:24,margin:7}} src={icons[provider.name]} alt={provider.name}/> </MenuItem>
                )}
              </Select>
            </FormControl>
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
              <Button onClick={handlePaymentModalClose} variant="outlined" sx={c2SecondaryBtnSx}>
                {t('cancel', { defaultValue: 'Cancelar' })}
              </Button>
              <Button variant="contained" type="submit" onClick={handlePaymentModalClose} sx={c2SuccessBtnSx}>
                {t('paynow_button', { defaultValue: 'Pagar ahora' })}
              </Button>
            </Box>
          </form>
          :null}
        </Box>
      </Modal>
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={modalInfo.mOpen}
        onClose={cancelOperation}
        className={classes.modal}
        container={rootRef.current}
      >
        <Box sx={{ ...c2ModalBoxSx, direction: isRTL === 'rtl' ? 'rtl' : 'ltr' }}>
            <Typography sx={{ fontFamily: C2_FONT, fontWeight: 800, fontSize: '1.15rem', color: '#1A0F3B', mb: 1 }}>
                {t('amount', { defaultValue: 'Monto' })}
            </Typography>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                id="amount"
                label={t('amount')}
                name="amount"
                autoComplete="amount"
                sx={c2TextFieldSx}
                onChange={(e)=>{
                  try{
                    if(e.target.value === ""){
                      setAmount(0);
                    }else{
                      setAmount(parseFloat(e.target.value));
                    }
                  }catch(e){
                    setCommonAlert({ open: true, msg: t('no_details_error')});
                    setAmount(0);
                  }          
                }}
                value={amount.toString()}
                autoFocus
                className={isRTL==='rtl'?classes.inputRtl:null}
                style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
                helperText={
                  modalInfo.mType === 'withdraw'
                    ? `Mínimo ${api.formatCop(api.MIN_REFERRAL_WITHDRAW || 100000)} · fee de plataforma ${api.REFERRAL_WITHDRAW_FEE_PERCENT || 5}%`
                    : undefined
                }
              />
          {modalInfo.mType === 'withdraw' && amount > 0 && api.computeReferralWithdrawFee ? (() => {
            const f = api.computeReferralWithdrawFee(amount);
            return (
              <Box sx={{ mt: 1, p: 1.5, borderRadius: '12px', backgroundColor: '#F4F2FE', border: '1px solid #D7CFEB' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>
                  <Typography sx={{ fontFamily: C2_FONT, fontSize: '0.85rem', color: '#766293' }}>Se descuenta de tu bono</Typography>
                  <Typography sx={{ fontFamily: C2_FONT, fontSize: '0.85rem', fontWeight: 700, color: '#1A0F3B' }}>{api.formatCop(f.gross)}</Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, mt: 0.5 }}>
                  <Typography sx={{ fontFamily: C2_FONT, fontSize: '0.85rem', color: '#766293' }}>Fee de plataforma ({f.feePercent}%)</Typography>
                  <Typography sx={{ fontFamily: C2_FONT, fontSize: '0.85rem', fontWeight: 700, color: '#B91C1C' }}>− {api.formatCop(f.fee)}</Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, mt: 0.75, pt: 0.75, borderTop: '1px solid #D7CFEB' }}>
                  <Typography sx={{ fontFamily: C2_FONT, fontSize: '0.9rem', fontWeight: 700, color: '#1A0F3B' }}>Recibes en tu cuenta</Typography>
                  <Typography sx={{ fontFamily: C2_FONT, fontSize: '0.95rem', fontWeight: 800, color: '#16A34A' }}>{api.formatCop(f.net)}</Typography>
                </Box>
              </Box>
            );
          })() : null}
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mt: 2 }}>
            <Button onClick={cancelOperation} variant="outlined" sx={c2SecondaryBtnSx}>
              {t('cancel', { defaultValue: 'Cancelar' })}
            </Button>
            <Button onClick={handleSubmit} variant="contained" sx={c2PrimaryBtnSx}>
              {modalInfo.mType === 'add'? t('add_to_wallet'): t('withdraw')}
            </Button>
          </Box>
        </Box>
      </Modal>
      <AlertDialog open={commonAlert.open} onClose={cancelOperation}>{commonAlert.msg}</AlertDialog>
      <AlertDialogTwoButton open={commonAlertTwoButton.open} onClose={cancelOperationTowButton} onGoto={gotoOperation}>{commonAlertTwoButton.msg}</AlertDialogTwoButton>
    </Box>
  );
}

export default UserWallet;
